import React, {useState} from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import backArrow from '../../../assets/images/arrow.svg';
import CircularLoader from '../../../utils/Loaders/CircularLoader';
import {
    NonNumericValidation, 
  } from '../../../utils/Validation.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

export default function CardForm(props) {
    const { pathname } = useLocation();
    const history = useHistory();
    var pq = pathname.split('/');
    const {id} = useParams();

    const [cardNoError, setCardNoError] = useState(null);
    const [expiryDateError, setExpiryDateError] = useState(null);
    const [cvvError, setCvvError] = useState(null);
    const [nameError, setNameError] = useState(null);
    const [streetError, setStreetError] = useState(null);
    const [cityError, setCityError] = useState(null);
    const [stateError, setStateError] = useState(null);
    const [zipError, setZipError] = useState(null);

    const handleCardNoChange = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.value;
        props.setData(updatedDetails);
        if(e.target.value === ''){
            setCardNoError('Card number is mandatory.')
        }else if(isNaN(e.target.value)){
            setCardNoError('Card number is a numeric field.')
        }else if(e.target.value.length > 20){
            setCardNoError('Max length of card number is 19 digits.')
        }else{
            setCardNoError(null);
        }
    }

    const handleExpiryChange = (e) => {
        let pq = moment(e).format('YYYY-MM').split('-');
        let updatedDetails = { ...props.data };
        updatedDetails['exp_year'] = pq[0];
        updatedDetails['exp_month'] = pq[1];
        props.setData(updatedDetails);

        let dt = new Date();
        let currentMonth = dt.getMonth()+1;
        let currentYear = dt.getFullYear();

        if(e === ''){
            setExpiryDateError('Card expiry date is mandatory.')
        }else if(parseInt(currentYear) > parseInt(pq[0])){
            setExpiryDateError('Card expiry date must be a future date.')
        }else if(parseInt(currentYear+10) < parseInt(pq[0])){
            setExpiryDateError('Max limit of card expiry date is 10 years.')
        }else if(parseInt(currentYear) >= parseInt(pq[0]) && parseInt(currentMonth) > parseInt(pq[1])){
            setExpiryDateError('Card expiry month must be a future date.')
        }else{
            setExpiryDateError(null);
        }
    }

    const handleCvvChange = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.value;
        props.setData(updatedDetails);
        if(e.target.value === ''){
            setCvvError('Card cvv is mandatory.')
        }else if(isNaN(e.target.value)){
            setCvvError('Card cvv is a numeric field which is 3 to 4 digit long.')
        }else if(e.target.value.length >= 5){
            setCvvError('Max length of card cvv is 4 digits.')
        }else{
            setCvvError(null);
        }
    }

    const handleNameChange = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.value;
        props.setData(updatedDetails);
        if(e.target.value === '')
        {
            setNameError('User name on card is mandatory.')
        }
        else if(! NonNumericValidation(e.target.value))
        {
            setNameError('User name is not valid.')
        }
        else if(e.target.value.length > 50)
        {
            setNameError('Max length of user name is 50 characters.')
        }
        else{
            setNameError(null);
        }
    }

    const handleStreetChange = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.value;
        props.setData(updatedDetails);
        if(e.target.value === ''){
            setStreetError('Street address is mandatory.')
        }
        else if(e.target.value.length > 200)
        {
            setStreetError('Max length of user name is 200 characters.')
        }
        else{
            setStreetError(null);
        }
    }

    const handleCityChange = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.value;
        props.setData(updatedDetails);
        if(e.target.value === ''){
            setCityError('City name is mandatory.')
        }
        else if(! NonNumericValidation(e.target.value))
        {
            setCityError('City name is not valid.')
        }
        else if(e.target.value.length > 25)
        {
            setCityError('Max length of user name is 25 characters.')
        }
        else{
            setCityError(null);
        }
    }

    const handleStateChange = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.value;
        props.setData(updatedDetails);
        if(e.target.value === ''){
            setStateError('State name is mandatory.')
        }
        else if(! NonNumericValidation(e.target.value))
        {
            setStateError('State name is not valid.')
        }
        else if(e.target.value.length > 25)
        {
            setStateError('Max length of user name is 25 characters.')
        }
        else{
            setStateError(null);
        }
    }

    const handleZipChange = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.value;
        props.setData(updatedDetails);
        if(e.target.value === ''){
            setZipError('Zip code is mandatory.')
        }
        else if(isNaN(e.target.value))
        {
            setZipError('Zip code is numeric field.')
        }
        else if(e.target.value.length > 10)
        {
            setZipError('Max length of user name is 10 characters.')
        }
        else{
            setZipError(null);
        }
    }

    const handleCardSaveCheck = (e) => {
        let updatedDetails = { ...props.data };
        updatedDetails[e.target.id] = e.target.checked;
        props.setData(updatedDetails);
    }

    const handleSaveButton = () => {
        if(props.data.card_number === ''){
            setCardNoError('Card number is mandatory.')
        }
        if(props.data.exp_year === '' || props.data.exp_month === ''){
            setExpiryDateError('Card expiry date is mandatory.')
        }
        if(props.data.cvv === ''){
            setCvvError('Card cvv is mandatory.')
        }
        if(props.data.name === ''){
            setNameError('User name on card is mandatory.')
        }
        if(props.data.street === ''){
            setStreetError('Street address is mandatory.')
        }
        if(props.data.city === ''){
            setCityError('City name is mandatory.')
        }
        if(props.data.state === ''){
            setStateError('State name is mandatory.')
        }
        if(props.data.zip_code === ''){
            setZipError('Zip code is mandatory.')
        }
        if(props.data.card_number !== '' && props.data.exp_month !== '' && props.data.exp_year !== '' && 
        props.data.cvv !== '' && props.data.name !== '' && props.data.street !== '' && props.data.city !== '' && 
        props.data.state !== '' && props.data.zip_code !== '' && !(cardNoError) && !(expiryDateError) && 
        !(cvvError) && !(nameError) &&!(streetError) && !(cityError) && !(stateError) && !(zipError)){
            let updatedDetails = { ...props.data };
            updatedDetails['address'] = props.data.street +', '+ props.data.city+', '+ props.data.state+', '+ props.data.zip_code;
            props.setData(updatedDetails);
            props.saveData(updatedDetails);
        }
    } 
    return (
        <>
        {props.loader && <CircularLoader />}
        <section className="Notifications-wrapper">
            <div className="container">
                <div className="Notifications">
                    <div className="row no-gutters">
                        <div className="col-md-9 col-sm-12 col-9 padding-rt">
                            <div className="generate">
                            <h3><img className="mr-2" src={backArrow} onClick={() => {
                          if(pathname === '/profile/cardList/addCard' || pathname === `/profile/cardList/editCard/${id}`){
                            history.push(`/profile/cardList`)
                          }else{
                            history.push(`/booking/listCards/${pq[pq.length-3]}/${pq[pq.length-2]}/${pq[pq.length-1]}`)
                          }
                        }} />{props.tittle}</h3>
                                <div className="new-payment-form">
                                    <div className="form-group">
                                        <input className={cardNoError ? "form-control borderRed" : "form-control" } disabled={props.editable}
                                        onChange={(e) => handleCardNoChange(e)} autoComplete='off' value={props.data.card_number} 
                                        id='card_number' type="text" placeholder="Card number" />
                                        {cardNoError && <span className='form-error'>{cardNoError}</span>}
                                    </div>
                                    <div className="form-group">
                                        <DatePicker
                                            className={expiryDateError ? "form-control borderRed month" : "form-control month" }
                                            selected={props.data.exp_year && new Date(props.data.exp_year + '-' + props.data.exp_month)}
                                            onChange={(e) => handleExpiryChange(e)}
                                            dateFormat="MMMM yyyy"
                                            showMonthYearPicker
                                            id='exp_date' 
                                            placeholderText='Select expiry date'
                                        />
                                        {expiryDateError && <span className='form-error'>{expiryDateError}</span>}
                                    </div>
                                    <div className="form-group">
                                        <input className={cvvError ? "form-control borderRed" : "form-control" } disabled={props.editable}
                                        onChange={(e) => handleCvvChange(e)} autoComplete='off' value={props.data.cvv} 
                                        id='cvv' type="text" placeholder="CVV" />
                                        {cvvError && <span className='form-error'>{cvvError}</span>}
                                    </div>
                                    <div className="form-group">
                                        <input className={nameError ? "form-control borderRed" : "form-control" }
                                        onChange={(e) => handleNameChange(e)} autoComplete='off' value={props.data.name} 
                                        id='name' type="text" placeholder="Name on card" />
                                        {nameError && <span className='form-error'>{nameError}</span>}
                                    </div>
                                    <div className="form-group">
                                        <input className={streetError ? "form-control borderRed" : "form-control" }
                                        onChange={(e) => handleStreetChange(e)} autoComplete='off' value={props.data.street} 
                                        id='street' type="text" placeholder="Street address" />
                                        {streetError && <span className='form-error'>{streetError}</span>}
                                    </div>
                                    <div className="form-group">
                                        <input className={cityError ? "form-control borderRed" : "form-control" }
                                        onChange={(e) => handleCityChange(e)} autoComplete='off' value={props.data.city} 
                                        id='city' type="text" placeholder="City" />
                                        {cityError && <span className='form-error'>{cityError}</span>}
                                    </div>
                                    <div className="form-group">
                                        <input className={stateError ? "form-control borderRed" : "form-control" }
                                        onChange={(e) => handleStateChange(e)} autoComplete='off' value={props.data.state} 
                                        id='state' type="text" placeholder="State" />
                                        {stateError && <span className='form-error'>{stateError}</span>}
                                    </div>
                                    <div className="form-group">
                                        <input className={zipError ? "form-control borderRed" : "form-control" }
                                        onChange={(e) => handleZipChange(e)} autoComplete='off' value={props.data.zip_code} 
                                        id='zip_code' type="text" placeholder="Zip code" />
                                        {zipError && <span className='form-error'>{zipError}</span>}
                                    </div>
                                    {props.btnName === 'Pay' && 
                                        <div className="comman-btn payment">
                                            <div className="text-wrap">
                                                <div className="form-group" style={{display:'flex', alignItems:'center'}}>
                                                    <input onChange={(e) => handleCardSaveCheck(e)} defaultChecked={props.data.toSave} type="checkbox" id='toSave' />
                                                    <label style={{paddingLeft: "15px", paddingBottom: '0'}}>Save this card for future payment</label><br />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="comman-btn payment">
                                        <button onClick={() => handleSaveButton()}>{props.btnName}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}
